import { render, staticRenderFns } from "./AddEditRequestModal.vue?vue&type=template&id=72f5528b"
import script from "./AddEditRequestModal.vue?vue&type=script&lang=js"
export * from "./AddEditRequestModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports